import React from 'react';
import './privacyPolicy.scss';

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <div className="privacypolicy">
        <div className="content-header">
          <div className="header">
            <h6>PRIVACY POLICY</h6>
            <h1 className="medium">ConsenSys AG's Alethio</h1>
            <p>Last Updated: December, 2018</p>
          </div>
        </div>

        <div className="main-content">
          <p>This privacy policy (<span className="bold">"Policy"</span>) describes how ConsenSys AG’s Alethio
            (<span className="bold">"Alethio"</span>, <span className="bold">"Company"</span>,
            <span className="bold"> "we"</span>, <span className="bold">"our"</span>, or <span className="bold">"us"</span>)
            collects, uses, shares and stores personal information of users of this
            website, <a href="https://ethstats.io/"
                        target="_blank"
                        rel="noopener noreferrer">https://ethstats.io/</a> (the <span className="bold">"Site"</span>). This
            Policy applies to the Site, applications, products and services
            (collectively, <span className="bold">"Services"</span>) on or in which it is posted, linked, or referenced.
          </p>
          <p>
            Please note that this Policy does not apply to information collected through third-party websites or services
            that you may access through the Services or that you submit to us through email, text message or other
            electronic message or offline.
          </p>
          <p>
            If you are visiting this site from the European Union (EU), see our Notice to EU Data Subjects below for our
            legal bases for processing and transfer of your data.
          </p>
          <br/>
          <p className="uppercase bold">What we collect</p>
          <p>We get information about you in a range of ways.</p>
          <p className="no-margin"><span className="bold">Information You Give Us. </span>Information we may collect from you includes:</p>
          <ul>
            <li>Contact information, such as your email address;</li>
            <li>Feedback and correspondence, such as information you provide in order to report a problem with Service,
              receive customer support or otherwise correspond with us;</li>
            <li>Technical information, such as your Ethereum wallet address;</li>
            <li>Usage information, such as information about how you use the Service and interact with us;</li>
            <li>Marketing information, such as your preferences for receiving marketing communications and details
              about how you engage with them.
            </li>
          </ul>
          <p><span className="bold">Information We Get From Others. </span>We may get information about you from other third party
            sources and we may add this to information we get from your use of the Services.
          </p>
          <p><span className="bold">Information Automatically Collected. </span>We may automatically record certain information
            about how you use our Site (we refer to this information as “Log Data“). Log Data may include information such as a user’s
            Internet Protocol (IP) address, device and browser type, operating system, the pages or features of our Site to which a user
            browsed and the time spent on those pages or features, the frequency with which the Site is used by a user, search terms, the links
            on our Site that a user clicked on or used, the last page you visited before entering our Site, your language preferences, your
            city and country location, and other statistics. We use this information to administer the Service and we
            analyze (and may engage third parties to analyze) this information to improve and enhance the Service by expanding its
            features and functionality and tailoring it to our users’ needs and preferences.
          </p>
          <p>
            We may use cookies or similar technologies to analyze trends, administer the website, track users’ movements around the website,
            and to gather demographic information about our user base as a whole. Users can control the use of cookies at the individual
            browser level. For more information, please see the section entitled “Cookies Policy” below.
          </p>
          <p>

            We also use Google Analytics to help us offer you an optimized user experience. You can find more information
            about Google Analytics' use of your personal data <a href="https://www.google.com/analytics/terms/us.html"
                                                                 target="_blank"
                                                                 rel="noopener noreferrer">here</a>.
          </p>
          <p><span className="bold">Information we will never collect. </span>We will never ask you to share your
            private keys or wallet seed. Never trust anyone or any site that asks you to enter your private keys or wallet seed.
          </p>
          <br/>
          <p className="uppercase bold">Use of personal information</p>
          <p className="italic bold no-margin">To provide our service</p>
          <p>We will use your personal information in the following ways:</p>
          <ul>
            <li>We use your email address to verify your identity when you access and use our Services and to identify which nodes are related to you.</li>
            <li>To identify, establish and maintain our relationship with you. </li>
            <li>To enable you to access and use the Services.</li>
            <li>To provide and deliver products and services that you may request.</li>
            <li>To send information, including confirmations, technical notices, updates, security alerts, and support
              and administrative messages.
            </li>
          </ul>
          <p className="italic bold no-margin">To comply with law</p>
          <p>
            We use your personal information as we believe necessary or appropriate to comply with applicable laws, lawful requests
            and legal process, such as to respond to subpoenas or requests from government authorities.
          </p>
          <p className="italic bold no-margin">To communicate with you</p>
          <p>
            We use your personal information to communicate about promotions, upcoming events, and other news about
            products and services offered by us.
          </p>
          <p className="italic bold no-margin">To optimize our platform</p>
          <p>
            In order to optimize your user experience, we may use your personal information to operate, maintain,
            and improve our Services. We may also use your information to respond to your comments and questions
            regarding the Services, and to provide you and other users with general customer service.
          </p>
          <p className="italic bold no-margin">With your consent</p>
          <p>
            We may use or share your personal information with your consent, such as when you consent to let us post
            your testimonials or endorsements on our Site, you instruct us to take a specific action with respect to
            your personal information, or you opt into third party marketing communications.
          </p>
          <p className="italic bold no-margin">For compliance, fraud prevention, and safety</p>
          <p>
            We may use your personal information to protect, investigate, and deter against fraudulent, unauthorized,
            or illegal activity.
          </p>
          <br/>
          <p className="bold uppercase">Sharing of personal information</p>
          <p>We do not share or sell the personal information that you provide us with other organizations without
            your express consent, except as described in this Privacy Policy. We disclose personal information to third
            parties under the following circumstances:
          </p>
          <ul>
            <li>
              <span className="bold">Affiliates. </span>We may disclose your personal information to our subsidiaries
              and corporate affiliates for purposes consistent with this Privacy Policy.
            </li>
            <li>
              <span className="bold">Business Transfers. </span>We may share personal information when we do a
              business deal, or negotiate a business deal, involving the sale or transfer of all or a part of our
              business or assets. These deals can include any merger, financing, acquisition, or bankruptcy transaction
              or proceeding.
            </li>
            <li>
              <span className="bold">Compliance with Laws and Law Enforcement; Protection and Safety. </span>We may
              share personal information for legal, protection, and safety purposes.
              <ul>
                <li>We may share information to comply with laws.</li>
                <li>We may share information to respond to lawful request sand legal processes.</li>
                <li>
                  We may share information to protect the rights and property of the Company, ouragents,
                  customers, and others. This includes enforcing our agreements, policies, and terms of use.
                </li>
                <li>
                  We may share information in an emergency. This includes protecting the safety of our employees and
                  agents, our customers, or any person.
                </li>
              </ul>
            </li>
            <li>
              <span className="bold">Professional Advisors and Service Providers. </span>We may share information
              with those who need it to do work for us. These recipients may include third party companies and individuals
              to administer and provide the Service on our behalf (such as customer support, hosting, email delivery
              and database management services), as well as lawyers, bankers, auditors, and insurers.
            </li>
            <li>
              <span className="bold">Other. </span>You may permit us to share your personal information with other
              companies or entities of your choosing. Those uses will be subject to the privacy policies of the recipient
              entity or entities.
            </li>
          </ul>
          <p>We may also share aggregated and/or anonymized data with others for their own uses.</p>
          <br/>
          <p className="bold uppercase">International transfer</p>
          <p>
            The Company has offices outside of the EU and has affiliates and service providers in the United States
            and in other countries. Your personal information may be transferred to or from the United States or other
            locations outside of your state, province, country or other governmental jurisdiction where privacy laws may
            not be as protective as those in your jurisdiction.
          </p>
          <p>
            EU users should read the important information provided below about transfer of personal information outside
            of the European Economic Area (EEA).
          </p>
          <br/>
          <p className="bold uppercase">How information is secured</p>
          <p>
            We retain personal information we collect as long as it is necessary and relevant to fulfill the purposes outlined
            in this privacy policy. In addition, we retain personal information to comply with applicable law where required,
            prevent fraud, resolve disputes, troubleshoot problems, assist with any investigation, and other actions permitted
            by law. To determine the appropriate retention period for personal information, we consider the amount, nature, and
            sensitivity of the personal information, the potential risk of harm from unauthorized use or disclosure of your personal
            information, the purposes for which we process your personal information and whether we can achieve those purposes
            through other means, and the applicable legal requirements.
          </p>
          <p>
            In some circumstances we may anonymize your personal information (so that it can no longer be associated
            with you) in which case we may use this information indefinitely without further notice to you.
          </p>
          <p>
            We employ industry standard security measures designed to protect the security of all information submitted
            through the Services. However, the security of information transmitted through the internet can never be guaranteed.
            We are not responsible for any interception or interruption of any communications through the internet or for
            changes to or losses of data. Users of the Services are responsible for maintaining the security of any password,
            biometrics, user ID or other form of authentication involved in obtaining access to password protected or secure
            areas of any of our digital services. In order to protect you and your data, we may suspend your use of any of
            the Services, without notice, pending an investigation, if any breach of security is suspected.
          </p>
          <br/>
          <p className="bold uppercase">Information choices and changes</p>
          <p className="no-margin bold italic">Accessing, Updating, Correcting, and Deleting your Information</p>
          <p>
            You may access information that you have voluntarily provided through your account on the Services, and
            to review, correct, or delete it by sending a request to privacy@aleth.io. You can request to change contact
            choices, opt-out of our sharing with others, and update your personal information and preferences.
          </p>
          <p className="bold no-margin">Tracking Technologies Generally</p>
          <p>
            Regular cookies may generally be disabled or removed by tools available as part of most commercial browsers,
            and in some instances blocked in the future by selecting certain settings. For more information, please see
            the section entitled "Cookies Policy" below.
          </p>
          <p className="bold no-margin">Google Analytics</p>
          <p>
            You may exercise choices regarding the use of cookies from Google Analytics by going
            to <a href="https://tools.google.com/dlpage/gaoptout"
                  target="_blank"
                  rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a> and
            downloading the Google Analytics Opt-out Browser Add-on.
          </p>
          <p>
            <span className="bold">Contact information. </span>We welcome your comments or questions about this Policy,
            and you may contact us at: privacy@aleth.io.
          </p>
          <p>
            <span className="bold">Changes to this privacy policy. </span>We may change this privacy policy at
            any time. We encourage you to periodically review this page for the latest information on our privacy practices.
            If we make any changes, we will change the Last Updated date above.
          </p>
          <p>
            Any modifications to this Privacy Policy will be effective upon our posting of the new terms and/or upon implementation
            of the changes to the Site (or as otherwise indicated at the time of posting).
          </p>
          <br/>
          <p className="bold uppercase">Eligibility</p>
          <p>
            Our Services are intended for general audiences over the age of 13 years old (or over the age of 16 if you are resident
            in the EEA). We do not knowingly collect information from children under the age of 13 years old, or 16 in the EEA. Consistent
            with the requirements of the Children's Online Privacy Protection Act (COPPA), if we learn that we have received any information
            directly from a child under age 13 without first receiving his or her parent's verified consent, we will use that information
            only to respond directly to that child (or his or her parent or legal guardian) to inform the child that he or she cannot use
            the Site and subsequently we will delete that information.
          </p>
          <br/>
          <p className="bold uppercase">Notice to California residents</p>
          <p>Under California Civil Code Section 1789.3, California users are entitled to the following consumer rights notice:
            California residents may reach the Complaint Assistance Unit of the Division of Consumer Services of the California
            Department of Consumer Affairs by mail at 1625 North Market Blvd., Sacramento, CA 95834, or by telephone
            at (916) 445-1254 or (800) 952-5210.
          </p>
          <br/>
          <p className="bold uppercase">Notice to EU data subjects</p>
          <p className="bold italic no-margin">Personal Information</p>
          <p>
            With respect to EU data subjects, "personal information," as used in this Privacy Policy, is equivalent
            to "personal data" as defined in
            the <a href="https://gdpr-info.eu/art-4-gdpr/"
                   target="_blank"
                   rel="noopener noreferrer">European Union General Data Protection Regulation</a> (GDPR).
          </p>
          <p className="bold italic no-margin">Sensitive Data</p>
          <p>
            Some of the information you provide us may constitute sensitive data as defined in the
            GDPR (also referred to as special categories of personal data).
          </p>
          <p className="bold italic no-margin">Legal Bases for Processing</p>
          <p>
            We only use your personal information as permitted by law. We are required to inform you of the legal bases of
            our processing of your personal information, which are described in the table below. If you have questions about
            the legal bases under which we process your personal information, contact us at privacy@aleth.io.
          </p>
          <div className="flex-row">
            <div className="table-header-item no-right-border italic bold centered">Processing Purpose</div>
            <div className="table-header-item italic bold centered">Legal Basis</div>
          </div>
          <div className="flex-row">
            <div className="table-item no-right-border">
              <div className="underline">To communicate with you</div>
              <br/>
              <div className="underline">To optimize our platform</div>
              <br/>
              <div className="underline">For compliance, fraud prevention, and safety</div>
              <br/>
              <div className="underline">To provide our service</div>
              <br/>
            </div>
            <div className="table-item">
              These processing activities constitute our legitimate interests. We make sure we consider and balance
              any potential impacts on you (both positive and negative) and your rights before we process your personal
              information for our legitimate interests. We do not use your personal information for activities where our
              interests are overridden by any adverse impact on you (unless we have your consent or are otherwise required
              or permitted to by law).
            </div>
          </div>
          <div className="flex-row">
            <div className="table-item no-right-border">
              <div className="underline">To comply with law</div>
            </div>
            <div className="table-item">
              We use your personal information to comply with applicable laws and our legal obligations.
            </div>
          </div>
          <div className="flex-row">
            <div className="table-item no-right-border">
              <div className="underline">With your consent</div>
            </div>
            <div className="table-item">
              Where our use of your personal information is based upon your consent, you have the right to withdraw
              it anytime in the manner indicated in the Service or by contacting us at privacy@aleth.io.
            </div>
          </div>
          <p className="italic bold">Use for New Purposes</p>
          <p>
            We may use your personal information for reasons not described in this Privacy Policy, where we are permitted
            by law to do so and where the reason is compatible with the purpose for which we collected it. If we need to
            use your personal information for an unrelated purpose, we will notify you and explain the applicable legal
            basis for that use. If we have relied upon your consent for a particular use of your personal information,
            we will seek your consent for any unrelated purpose.
          </p>
          <p className="italic bold">Your Rights</p>
          <p>
            Under the GDPR, you have certain rights regarding your personal information. You may ask us to take the
            following actions in relation to your personal information that we hold:
          </p>
          <ul>
            <li>
              <span className="bold">Opt-out. </span>Stop sending you direct marketing communications which you
              have previously consented to receive. We may continue to send you Service-related and other
              non-marketing communications.
            </li>
            <li>
              <span className="bold">Access. </span>Provide you with information about our processing of your
              personal information and give you access to your personal information.
            </li>
            <li>
              <span className="bold">Correct. </span>Update or correct inaccuracies in your personal information.
            </li>
            <li>
              <span className="bold">Delete. </span>Delete your personal information.
            </li>
            <li>
              <span className="bold">Transfer. </span>Transfer a machine-readable copy of your personal
              information to you or a third party of your choice.
            </li>
            <li>
              <span className="bold">Restrict. </span>Restrict the processing of your personal information.
            </li>
            <li>
              <span className="bold">Object. </span> Object to our reliance on our legitimate interests as
              the basis of our processing of your personal information that impacts your rights.
            </li>
          </ul>
          <p>
            You can submit these requests by email to privacy@aleth.io. We may request specific information from
            you to help us confirm your identity and process your request. Applicable law may require or permit us
            to decline your request. If we decline your request, we will tell you why, subject to legal
            restrictions. If you would like to submit a complaint about our use of your personal information or
            response to your requests regarding your personal information, you may contact us at privacy@aleth.io
            or submit a complaint to the data protection regulator in your jurisdiction.
            You can find your data protection
            regulator <a href="http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm"
                         target="_blank"
                         rel="noopener noreferrer">here</a>.
          </p>
          <p className="italic bold">Cross-Border Data Transfer</p>
          <p>
            Please be aware that your personal data will be transferred to, processed, and stored in the United States.
            Data protection laws in the U.S. may be different from those in your country of residence. Whenever we
            transfer your personal information out of the EEA to the U.S. or countries not deemed by the European
            Commission to provide an adequate level of personal information protection, the transfer will be based on a
            data transfer mechanism recognized by the European Commission as providing adequate protection for personal information.
          </p>
          <p>
            Please contact us if you want further information on the specific mechanism used by us when
            transferring your personal information out of the EEA.
          </p>
          <br/>
          <p className="bold uppercase">Cookies Policy</p>
          <p>
            We understand that your privacy is important to you and are committed to being transparent about the
            technologies we use. In the spirit of transparency, this policy provides detailed information about
            how and when we use cookies on our Site.
          </p>
          <p className="bold italic">Do we use Cookies?</p>
          <p>
            Yes. We and our marketing partners, affiliates, and analytics or service providers use cookies, web beacons,
            or pixels and other technologies to ensure everyone who uses the Site has the best possible experience.
          </p>
          <p className="bold italic">What is a Cookie?</p>
          <p>
            A cookie ("Cookie") is a small text file that is placed on your hard drive by a web page server.
            Cookies contain information that can later be read by a web server in the domain that issued the cookie
            to you. Some of the cookies will only be used if you use certain features or select certain preferences,
            and some cookies will always be used. You can find out more about each cookie by viewing our current cookie
            list below. We update this list periodically, so there may be additional cookies that are not yet listed.
            Web beacons, tags and scripts may be used in the Site or in emails to help us to deliver cookies, count visits,
            understand usage and campaign effectiveness and determine whether an email has been opened and acted upon.
            We may receive reports based on the use of these technologies by our service/analytics providers on
            an individual and aggregated basis.
          </p>
          <p className="bold italic">Why do we use Cookies?</p>
          <p>We generally use Cookies for the following purposes:</p>
          <ul>
            <li>To recognize new or past customers.</li>
            <li>To store your password if you are registered on our Site.</li>
            <li>To improve our Site and to better understand your visits on our platforms and Site.</li>
            <li>To serve you with interest-based or targeted advertising.</li>
            <li>To observe your behaviors and browsing activities over time across multiple websites or other platforms.</li>
            <li>To better understand the interests of our customers and our website visitors.</li>
          </ul>
          <p>
            Some Cookies are necessary for certain uses of the Site, and without such Cookies, we would not be able to
            provide many services that you need to properly use the Site. These Cookies, for example, allow us to
            operate our Site so you may access it as you have requested and let us recognize that you have created
            an account and have logged into that account to access Site content. They also include Cookies that enable us
            to remember your previous actions within the same browsing session and secure our Sites.
          </p>
          <p>
            We also use functional Cookies and Cookies from third parties for analysis and marketing purposes. Functional
            Cookies enable certain parts of the site to work properly and your user preferences to remain known. Analysis
            Cookies, among other things, collect information on how visitors use our Site, the content and products that
            users view most frequently, and the effectiveness of our third party advertising. Advertising Cookies assist
            in delivering ads to relevant audiences and having our ads appear at the top of search results. Cookies are
            either “session” Cookies which are deleted when you end your browser session, or “persistent,” which remain
            until their deletion by you (discussed below) or the party who served the cookie. Full details on all of the
            Cookies used on the Site are available at our Cookie Disclosure table below.
          </p>
          <p className="bold italic">How to disable Cookies</p>
          <p>
            You can generally activate or later deactivate the use of cookies through a functionality built into your
            web browser. To learn more about how to control cookie settings through your browser:
          </p>
          <p>
            Click <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                     target="_blank "
                     rel="noopener noreferrer">here</a> to
            learn more about the “Private Browsing” setting and managing cookie settings in Firefox;
          </p>
          <p>
            Click <a href="https://support.google.com/chrome/answer/95647?hl=en"
                     target="_blank "
                     rel="noopener noreferrer">here</a> to learn more about “Incognito” and managing cookie
            settings in Chrome;
          </p>
          <p>
            Click <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                     target="_blank "
                     rel="noopener noreferrer">here</a> to learn more about “InPrivate” and managing cookie
            settings in Internet Explorer;
          </p>
          <p>
            Click <a href="hhttps://support.apple.com/en-us/HT201265"
                     target="_blank "
                     rel="noopener noreferrer">here</a> to learn more about “Private Browsing” and managing cookie
            settings in Safari.
          </p>
          <p>
            If you want to learn more about cookies, or how to control, disable or delete them, please
            visit <a href="http://www.aboutcookies.org"
                     target="_blank"
                     rel="noopener noreferrer">http://www.aboutcookies.org</a> for detailed guidance. In addition,
            certain third party advertising networks, including Google, permit users to opt out of or customize
            preferences associated with your internet browsing. To learn more about this feature from Google,
            click <a href="https://adssettings.google.com/u/0/authenticated?hl=en"
                     target="_blank"
                     rel="noopener noreferrer">here</a>.
          </p>
          <p>
            To control flash cookies, which we may use on our Site from time to time, you can go to
            this <a href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
                    target="_blank"
                    rel="noopener noreferrer">link</a> because Flash cookies cannot be controlled through your browser
            settings. Please note that if you decline the use of Cookies, some functions of the website may be unavailable
            and we will not be able to present personally tailored content and advertisements to you.
          </p>
          <p>
            We may link the information collected by Cookies with other information we collect from you pursuant to
            this Privacy Policy and use the combined information as set forth herein. Similarly, the third parties who
            serve cookies on our Site may link your name or email address to other information they collect, which may
            include past purchases made offline or online, or your online usage information. If you are located in
            the European Economic Area, you have certain rights that are described above under the header
            "Notice to EU Data Subjects", including the right  to inspect and correct or delete the data
            that we have about you.
          </p>
          <br/>
          <p className="underline bold">Cookies Disclosure</p>
          <div className="divTable">
            <div className="divTableBody">
              <div className="divTableRow">
                <div className="divTableCell">Name of Cookie/Identifier</div>
                <div className="divTableCell">What does the cookie generally do (e.g., website function and administration, analytics, marketing)?</div>
                <div className="divTableCell">Is it a 1<sup>st</sup> or 3<sup>rd</sup> party cookie and what is the name of the party providing it?</div>
                <div className="divTableCell">What type of cookie is it (persistent or session)?</div>
                <div className="divTableCell">What is the duration of the cookie on the website (if not cleared by the user)?</div>
              </div>
              <div className="divTableRow">
                <div className="divTableCell">Google Analytics (_ga)</div>
                <div className="divTableCell">Analytics</div>
                <div className="divTableCell">3rd - Google</div>
                <div className="divTableCell">Persistent</div>
                <div className="divTableCell">[2 years]</div>
              </div>
              <div className="divTableRow">
                <div className="divTableCell">(_gid)</div>
                <div className="divTableCell">Analytics</div>
                <div className="divTableCell">3rd - Google</div>
                <div className="divTableCell">Persistent</div>
                <div className="divTableCell">[1 day]</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicy;

